<template>
  <div :class="rootClass">
    <ul :class="rootClass + '__wrapper'" style="height: 500px; overflow-y: scroll;">

      <!-- Logo -->
      <li v-if="platform === 'all'" :class="rootClass + '__item'" style="position: relative;">
        <button class="btn btn-round btn-sm btn-primary" style="position: absolute; left: 8px; z-index: 44; font-size: 11px; padding: 7px;">
          Logo
        </button>
        <button v-if="account.role === 'admin'" @click="copy(company.logo)" class="btn btn-round btn-sm btn-primary" style="position: absolute; left: 8px; z-index: 44; font-size: 11px; padding: 7px;">
          Copy URL
        </button>
        <img :src="company.logo" :height="120" :width="120" :class="rootClass + '__img'" />
      </li>

      <!-- Background -->
      <li v-if="platform === 'all'" :class="rootClass + '__item'" style="position: relative;">
        <button class="btn btn-round btn-sm btn-primary" style="position: absolute; left: 8px; z-index: 44; font-size: 11px; padding: 7px;">
          Background
        </button>
        <button v-if="account.role === 'admin'" @click="copy(company.bg)" class="btn btn-round btn-sm btn-primary" style="position: absolute; left: 8px; z-index: 44; font-size: 11px; padding: 7px;">
          Copy URL
        </button>
        <img :src="company.bg" :height="h" :width="w" :class="rootClass + '__img'" />
      </li>

      <!-- Media -->
      <li v-for="(media, index) in medias" :key="index" :class="rootClass + '__item'" style="position: relative; cursor: pointer;">
        <button v-if="showButtons" @click="removeMedia(media.id)" class="btn btn-round btn-sm btn-icon btn-danger" style="position: absolute; right: 8px; z-index: 44;">
          <i class="now-ui-icons ui-1_simple-remove"></i>
        </button>
        <button v-if="showButtons" class="btn btn-round btn-sm btn-primary" style="position: absolute; left: 8px; z-index: 44; font-size: 11px; padding: 7px;">
          {{ media.platform === 'captive' ? 'App' : 'Billboard'}}
        </button>
        <div v-if="platform === 'all' || media.platform === platform"
          :class="classThumbnailMultiple(media.url)"
          @click="onSelectMultipleImage(media, $event)">
          <button v-if="account.role === 'admin'" @click="copy(media.url)" class="btn btn-round btn-sm btn-primary" style="position: absolute; left: 5px; bottom: 5px; z-index: 44; font-size: 11px; padding: 3px;">
            Copy URL
          </button>
          <img v-if="media.type === 'img'" :src="media.url"
               :height="h"
               :width="w"
               :class="rootClass + '__img'">
          <video v-if="media.type === 'video'"
               :height="h"
               :width="w"
               :class="rootClass + '__img'" controls>
            <source :src="media.url" type="video/mp4">
          </video>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import Company from '../services/Company';
  import to from 'await-to-js';

  export default {
    name: 'gallery',
    props: {
      platform: {
        type: String,
        default: 'all'
      },
      isMultiple: {
        type: Boolean,
        default: true
      },
      rootClass: {
        type: String,
        default: 'vue-select-image'
      },
      activeClass: {
        type: String,
        default: '--selected'
      },
      h: {
        type: String,
        default: 'auto'
      },
      w: {
        type: String,
        default: 'auto'
      },
      showButtons: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        multipleSelected: [],
        medias: [],
        initialSelected: []
      }
    },
    computed: {
      ...mapGetters(['selectedImages', 'galleryMedias', 'posts', 'billboardPosts']),
      cp() { // computed property will be updated when async call resolves
        return this.galleryMedias;
      }
    },
    mounted() {
      if(this.galleryMedias) {
        let counter = 1;
        this.galleryMedias.forEach(media => {
          this.medias.push(media);
        });
      }
      this.multipleSelected = this.selectedImages;
      this.setInitialSelection();
    },
    watch: {
      selectedImages(newValue, oldValue) {
        this.multipleSelected = this.selectedImages;
      },
      cp(newValue, oldValue) {
        newValue.forEach(media => {
          this.medias.push(media);
        });
      },
      multipleSelected(newValue, oldValue) {
        this.setSelectedMedias(this.multipleSelected);
      },
      galleryMedias (newValue) {
        this.medias = newValue
      }
    },
    methods: {
      ...mapActions(['setSelectedMedias', 'fetchGalleryMedias', 'fetchAccount']),
      async removeMedia(id) {
        this.prompt(async () => {
          const [err, response] = await to(Company.removeMedia(id));
          if (err) return this.errorSnack(err);
          if (response.data.success) {
            this.fetchGalleryMedias();
            return this.successSnack(this.$ml.get('success'));
          }
        })
      },
      classThumbnailMultiple(url) {
        const baseClass = `${this.rootClass}__thumbnail`
        const baseMultipleClass = `${baseClass} is--multiple`
        if (this.isExistInArray(url)) {
          return `${baseMultipleClass} ${baseClass}${this.activeClass}`
        }
        return `${baseMultipleClass}`
      },
      isExistInArray (url) {
        return this.multipleSelected.find((item) => {
          return url === item.url
        })
      },
      removeFromMultipleSelected (url, dontFireEmit) {
        this.multipleSelected = this.multipleSelected.filter((item) => {
          return url !== item.url
        })
        if (!dontFireEmit) {
          this.$emit('onselectmultipleimage', this.multipleSelected)
        }
      },
      resetMultipleSelection () {
        this.multipleSelected = []
      },
      onSelectMultipleImage(objectImage, e) {
        this.$emit('onGalleryMediaSelect', e);
        if (!this.isExistInArray(objectImage.url)) {
          if (!this.isMultiple) this.multipleSelected = [];
          this.multipleSelected.push(objectImage)
        } else {
          this.removeFromMultipleSelected(objectImage.url, true)
        }
        this.$emit('onselectmultipleimage', this.multipleSelected)
      },
      setInitialSelection () {
        if (this.selectedImages) {
          this.multipleSelected = [].concat(this.selectedImages)
        }
      }
    }
  }
</script>

<style>

  .vue-select-image__wrapper {
    overflow: auto;
    list-style-image: none;
    list-style-position: outside;
    list-style-type: none;
    padding: 0px;
    margin: 0px;
  }

  .vue-select-image__item {
    margin: 0px 12px 12px 0px;
    float: left;
  }

  .vue-select-image__thumbnail{
    padding: 6px;
    border: 1px solid #dddddd;

    display: block;
    padding: 4px;
    line-height: 20px;
    border: 1px solid #ddd;

    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;

    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.055);
    -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.055);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.055);

    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
  }

  .vue-select-image__thumbnail--selected{
    background: #0088cc;
  }

  .vue-select-image__img{
    -webkit-user-drag: none;
    display: block;
    max-width: 100%;
    margin-right: auto;
    margin-left: auto;
  }

  .vue-select-image__lbl{
    line-height: 3;
  }
</style>
